<script setup>
import { ref } from 'vue';
import SettingsMenu from '@/components/settings-menu';
import GlobalSnackbar from '@/components/commons/global-snack';
import UserMenu from '@/components/commons/user-menu';
const drawer = ref(false);
</script>

<template>
  <div data-theme="parmazip">
    <!-- DIALOGS START -->
    <global-snackbar />
    <!-- DIALOGS END -->

    <div class="flex h-screen">
      <!-- Mobile overlay -->
      <div v-if="drawer" class="fixed inset-0 z-40 lg:hidden" @click="drawer = false">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <!-- Sidebar -->
      <div
        class="fixed inset-y-0 left-0 z-50 bg-gradient-to-b from-white to-gray-50 h-screen w-64 lg:w-80 transform lg:transform-none transition-transform duration-300 flex-shrink-0"
        :class="drawer ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'"
      >
        <header class="nav flex p-2 justify-between items-center z-10 h-16 header border-b border-gray-200">
          <div class="flex-1 px-2 mx-2">
            <h1 class="text-neutral text-8 font-medium flex items-center gap-2">
              <nuxt-link class="p-2 rounded-md hover:bg-gray-100 transition-colors" to="/dashboard">
                <i class="la la-arrow-left text-2xl"></i>
              </nuxt-link>
              Settings
            </h1>
          </div>
        </header>
          <SettingsMenu @close="drawer = false;" />
      </div>

      <div class="flex flex-col w-full lg:ml-80">
        <header
          class="nav flex justify-between lg:justify-end bg-gradient-to-r from-white via-white to-gray-50/50 border-b border-gray-200 items-center fixed top-0 right-0 z-30 h-16 backdrop-blur-md left-0 lg:left-80 w-full lg:w-[calc(100%-20rem)]">
          <div class="flex-none lg:hidden">
            <button
              @click="drawer = !drawer"
              aria-label="open sidebar"
              class="p-2 rounded-md hover:bg-gradient-to-r hover:from-gray-100 hover:to-gray-200 transition-all duration-200 group"
            >
              <i class="las la-bars text-2xl text-gray-700 group-hover:text-gray-900 transition-colors"></i>
            </button>
          </div>
          <div class="flex-none flex items-center justify-center">
            <user-menu />
          </div>
        </header>
        <div class="flex flex-col min-h-screen bg-gray-50 pt-16">
          <main class="flex-1 p-4 lg:p-6">
            <NuxtPage />
          </main>
        </div>
      </div>
    </div>
  </div>
</template>
